import React from "react";
const Slider = () => {
  return (
    <>
      <div className="slider">
        <section className="section bg-home align-items-center d-flex ">
          <div className="container-lg">
            <div className="row">
              <div className="col-lg-12 col-md-12 mb-2">
                <div className="text-white">
                  <h1 className="heading-title slider-title pb-5">
                    We Are Buliding Something
                  </h1>

                  <div className="content mt-3">
                    <div className="content__container">
                      <ul className="content__container__list">
                        <li className="content__container__list__item">New!</li>
                        <li className="content__container__list__item">
                          Awesome!
                        </li>
                        <li className="content__container__list__item">
                          {" "}
                          Flawless!
                        </li>
                        <li className="content__container__list__item">
                          Cool!
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="offset-lg-2 col-lg-8">
                    <p className="font-size-8 mt-3">
                      All Your Propery Documents in one place...Download them on
                      the go...No need to jump in for Mulitple Websites
                    </p>
                  </div>
                  <div className="pt-3 mt-3">
                    <a
                      href="#"
                      className="btn btn-primary btn-round  home-button mt-3 shadow-lg"
                    >
                      Launching Soon
                      <span className="play-shadow ms-2">
                        <span className="home-btn">
                          <i
                            className="fa fa-caret-right"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Slider;
